import { useQuery } from "@tanstack/react-query";
import { useAuth } from "./useAuth";
import { StakeholderPermissionClaims } from "@freetech/models/user";
import { createEmptyStakeholderPermissions } from "constants/stakeholderPermissions";

export function useStakeholderPermissions() {
  const { userInfo, isLoading: userLoading } = useAuth();

  const query = useQuery({
    queryKey: ["stakeholderPermissions", userInfo?.id],
    queryFn: () => {
      if (!userInfo) {
        return createEmptyStakeholderPermissions();
      }

      if (
        !userInfo.permissions ||
        userInfo.permissions === null ||
        Object.keys(userInfo.permissions).length === 0
      ) {
        return createEmptyStakeholderPermissions();
      }

      return userInfo.permissions as StakeholderPermissionClaims;
    },
    enabled: !userLoading && !!userInfo && userInfo.role === "stakeholder",
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    permissions: query.data || createEmptyStakeholderPermissions(),
    isPermissionsLoading: query.isLoading,
    ...query,
  };
}
